/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 注文種別（01:即時配車, 02: 日時指定）
 * @export
 * @enum {number}
 */
export enum OrderTypeEnum {
    /** 即時配車 */
    IMMEDIATE_DISPATCH = '01',
    /** 日時指定 */
    SCHEDULED_DISPATCH = '02'
}

/**
 * 注文種別（01:即時配車, 02: 日時指定） の Union 型
 * @export
 * @typedef OrderType
 */
export type OrderType =
  typeof OrderTypeEnum[keyof typeof OrderTypeEnum];

/**
 * 注文種別（01:即時配車, 02: 日時指定） のラベルマップ
 * @export
 */
export const OrderTypeLabels = {
    /**
     * 数値キー: OrderTypeEnum.IMMEDIATE_DISPATCH
     * 名前キー:  IMMEDIATE_DISPATCH
     */
    [OrderTypeEnum.IMMEDIATE_DISPATCH]: '即時配車',
    IMMEDIATE_DISPATCH:                             '即時配車',
    /**
     * 数値キー: OrderTypeEnum.SCHEDULED_DISPATCH
     * 名前キー:  SCHEDULED_DISPATCH
     */
    [OrderTypeEnum.SCHEDULED_DISPATCH]: '日時指定',
    SCHEDULED_DISPATCH:                             '日時指定',
} as const;

/**
 * 注文種別（01:即時配車, 02: 日時指定） のラベル Union 型
 * @export
 * @typedef OrderTypeLabel
 */
export type OrderTypeLabel =
  typeof OrderTypeLabels[keyof typeof OrderTypeLabels];

/**
 * 注文種別（01:即時配車, 02: 日時指定） のラベル取得関数
 * @export
 * @param { OrderType } value - 列挙体の値
 * @returns { OrderTypeLabel } ラベル文字列
 */
export function getOrderTypeLabel(
  value: OrderType
): OrderTypeLabel {
  return OrderTypeLabels[value];
}

/**
 * 注文種別（01:即時配車, 02: 日時指定） のラベル配列を取得する関数
 * @export
 * @param { OrderType[] } values - 列挙体の値配列
 * @returns { OrderTypeLabel[] } ラベル文字列配列
 */
export function getOrderTypeLabels(values: OrderType[]): OrderTypeLabel[] {
  return values.map((value) => getOrderTypeLabel(value));
}

/**
 * 注文種別（01:即時配車, 02: 日時指定） のラベル配列
 * @export
 */
export const OrderTypeLabelList = [
  '即時配車','日時指定',
] as const;

